'use es6';

import PropTypes from 'prop-types';
import React from 'react';
import { OrderedSet } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterSideNav from 'ui-addon-react-router/UIRouterSideNav';
import UIRouterSideNavItem from 'ui-addon-react-router/UIRouterSideNavItem';
import withPartials from 'marketplace-lib/components/hocs/withPartials';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';

var CategoryNavigation = function CategoryNavigation(_ref) {
  var categoryFilter = _ref.categoryFilter,
      options = _ref.options,
      parent = _ref.parent,
      partial = _ref.partial,
      trackAdjustedFilter = _ref.trackAdjustedFilter,
      trackLinkClick = _ref.trackLinkClick;

  var handleTrackAdjustedFilter = function handleTrackAdjustedFilter(value) {
    trackAdjustedFilter(GoodFiltersAndPage.SUB_TYPE, value);
  };

  return React.createElement("div", null, React.createElement(UIRouterSideNav, null, React.createElement(UIRouterSideNavItem, {
    onClick: trackLinkClick.bind(null, "view-installed-" + parent),
    to: "/manage-purchases?subType=" + parent,
    title: React.createElement(FormattedMessage, {
      message: "sidebar.purchasedLabel." + parent
    })
  })), React.createElement(UIRouterSideNav, {
    divider: true,
    value: categoryFilter
  }, React.createElement(UIRouterSideNavItem, {
    onClick: partial(handleTrackAdjustedFilter, parent),
    title: React.createElement(FormattedMessage, {
      message: "sidebar.allCategoryLabel." + parent
    }),
    to: "/products?subType=" + parent,
    value: parent
  }), options.map(function (option) {
    return React.createElement(UIRouterSideNavItem, {
      key: option.value,
      className: "integrate-category-" + option.value,
      defaultOpen: categoryFilter === option.value,
      onClick: partial(handleTrackAdjustedFilter, option.value),
      value: option.value,
      title: option.text,
      to: "/products?subType=" + option.value
    }, option.options && option.options.map(function (childOption) {
      return React.createElement(UIRouterSideNavItem, {
        key: childOption.value,
        className: "integrate-category-" + childOption.value,
        onClick: partial(handleTrackAdjustedFilter, childOption.value),
        value: childOption.value,
        title: childOption.text,
        to: "/products?subType=" + childOption.value
      });
    }));
  })));
};

CategoryNavigation.propTypes = {
  categoryFilter: PropTypes.string.isRequired,
  options: PropTypes.instanceOf(OrderedSet).isRequired,
  parent: PropTypes.string.isRequired,
  partial: PropTypes.func.isRequired,
  trackAdjustedFilter: PropTypes.func.isRequired,
  trackLinkClick: PropTypes.func.isRequired
};
export default withPartials(CategoryNavigation);